<template>
    <v-data-table :headers="headers" :items="preguntas" hide-actions :loading="loading" class="elevation-1">
        <template v-slot:items="props">
            <td>{{ props.item.label }}</td>
            <td>{{ tipoLabel(props.item.type) }}</td>
            <td>
                <span v-if="props.item.options && props.item.options.length">
                    {{ props.item.options.join(', ') }}
                </span>
            </td>
            <td style="text-align: center;">
                <v-icon v-if="props.item.required" color="orange">check_circle</v-icon>
            </td>
            <td style="text-align: center;">
                <v-icon small @click="subir(props.index)" :disabled="props.index === 0">arrow_upward</v-icon>
                <v-icon small @click="bajar(props.index)" :disabled="props.index === preguntas.length - 1">arrow_downward</v-icon>
                <v-icon small class="ml-2" @click="$emit('editar', props.item)">edit</v-icon>
                <v-icon small class="ml-2" @click="borrar(props.item)">delete</v-icon>
            </td>
        </template>
    </v-data-table>
</template>

<script>
import camposCustomApi from '../../../../../api/camposCustom';

export default {
    name: 'PreguntasTabla',
    props: {
        eventoId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            preguntas: [],
            headers: [
                { text: 'Pregunta', value: 'label', sortable: false },
                { text: 'Tipo', value: 'type', sortable: false },
                { text: 'Opciones', value: 'options', sortable: false },
                { text: 'Obligatoria', value: 'required', sortable: false, align: 'center' },
                { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
            ],
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.loading = true;
            camposCustomApi.list(this.eventoId)
                .then((data) => {
                    this.preguntas = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        tipoLabel(type) {
            const labels = {
                texto: 'Texto',
                seleccion_unica: 'Selección única',
                seleccion_multiple: 'Selección múltiple',
            };
            return labels[type] || type;
        },
        borrar(pregunta) {
            if (!confirm(`¿Borrar la pregunta "${pregunta.label}"?`)) {
                return;
            }
            camposCustomApi.remove(pregunta.id).then(() => this.loadData());
        },
        subir(index) {
            if (index === 0) return;
            this.intercambiar(index, index - 1);
        },
        bajar(index) {
            if (index === this.preguntas.length - 1) return;
            this.intercambiar(index, index + 1);
        },
        intercambiar(i, j) {
            const nuevoOrden = [...this.preguntas];
            [nuevoOrden[i], nuevoOrden[j]] = [nuevoOrden[j], nuevoOrden[i]];
            this.preguntas = nuevoOrden;
            camposCustomApi.reorder(this.eventoId, nuevoOrden.map((p) => p.id))
                .then(() => this.loadData());
        },
    },
};
</script>
